const PDF_OPTIONS = {
  margin: 18,
  image: { type: "jpeg" as const, quality: 0.95 },
  html2canvas: { scale: 2, useCORS: true, logging: false },
  jsPDF: { unit: "mm" as const, format: "a4" as const, orientation: "portrait" as const },
  pagebreak: { mode: ["avoid-all", "css"] },
};

async function loadHtml2Pdf() {
  const module = await import("html2pdf.js");
  return module.default;
}

/**
 * Generate a PDF from an HTML string and trigger a browser download.
 * Creates a hidden container, renders the HTML, then removes it.
 */
export async function generatePdfFromHtml(html: string, filename: string): Promise<void> {
  const html2pdf = await loadHtml2Pdf();
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.left = "-9999px";
  container.style.top = "0";
  container.innerHTML = html;
  document.body.appendChild(container);

  try {
    await html2pdf()
      .set({ ...PDF_OPTIONS, filename })
      .from(container)
      .save();
  } finally {
    document.body.removeChild(container);
  }
}

/**
 * Generate a PDF from a visible HTML element and trigger a browser download.
 */
export async function generatePdfFromElement(element: HTMLElement, filename: string): Promise<void> {
  const html2pdf = await loadHtml2Pdf();
  await html2pdf()
    .set({ ...PDF_OPTIONS, filename })
    .from(element)
    .save();
}
